import axios from 'axios';
import env from '../Utils/env';


axios.defaults.baseURL =  env.baseURL; 
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Accept'] = 'application/json';
axios.defaults.withCredentials = true;

export const login = async (email, password) => {
  try {

    const response = await axios.post(`/login`, {
      email,
      password,
    });
    

    if (response.data.token && response.data.user) {

      
      return response.data;

    } else {

      throw new Error('Authentication failed');
    }
  } catch (error) {

    const errorMessage = error.response?.data?.message || 'La connexion a échoué. Veuillez réessayer.';
    throw new Error(errorMessage);

  }
};

